import React, { useState, useEffect } from 'react';
import Loader from '../../atoms/icons/loader';
import indexFilterKeys from '../../pages/markets/json/index-filter-keys.json'
import industryFilterKeys from '../../pages/markets/json/industry-filter-keys.json';
import marketCapFilterKeys from '../../pages/markets/json/market-cap-filter-keys.json';
import groupFilters from '../../pages/markets/json/stock-stats-group-filters.json';
import mainFilters from '../../pages/markets/json/stock-stats-main-filters.json';
import Select from 'react-select';
import { BQLink } from '../../atoms/bqlink';
import { useQuery } from 'react-query';
import { ChevronRightIcon, HomeAnalyticsIcon } from '../../atoms/material-icons';
import './stock-stats.m.css';
import EmptyState from '../empty-state'

const StockStats = () => {
  const [stocks, setStocks] = useState({});
  const [selectedDuration, setSelectedDuration] = useState('1D');
  const [selectedFilter, setSelectedFilter] = useState('top_gainers');
  const [selectedGroup, setSelectedGroup] = useState('index');
  const [filterKey, setFilterKey] = useState(129);
  const [filterKeys, setFilterKeys] = useState([...indexFilterKeys]);
  const [Loading, setLoading] = useState(false);
  const [MainFilterName, setMainFilterName] = useState('Top Gainers');
  const [selectedGroupName, setSelectedGroupName] = useState('Indices');
  const [FilterkeyName, setFilterKeyName] = useState('NIFTY 500');
  const [initialLoading, setInitialLoading] = useState(true);
  const [durations, setDurations] = useState({
    oneD: true,
    oneW: false,
    oneM: false,
    oneYTD: false,
    oneY: false,
    threeY: false,
    fiveY: false,
    tenY: false
  });

  const [activeFilter, setActiveFilter] = useState({
    top_gainers: true,
    top_losers: false,
    most_active_by_value: false,
    price_inc_vol_inc: false,
    price_inc_vol_dec: false,
    price_dec_vol_inc: false,
    price_dec_vol_dec: false,
    price_flat_vol_inc: false,
    '52_week_high': false,
    '52_week_low': false,
    close_to_52_week_high: false,
    close_to_52_week_low: false,
    volatility: false,
    fall_from_high: false,
    recovery_from_low: false,
    bulk_deal: false,
    block_deal: false,
    insider: false,
    only_buyers: false,
    only_sellers: false
  });

  const fetchUpdatedStockData = async (
    type = 'top_gainers',
    filterKey = 'index',
    filterValue = '129',
    duration = '1D'
  ) => {
    const response = await fetch(
      `/feapi/markets/stock-stats/${type}/${filterKey}/${filterValue}/${duration}`
    );
    return response.json();
  };

  const resultFetchedStockData = useQuery(
    'getStockData',
    () => fetchUpdatedStockData(selectedFilter, selectedGroup, filterKey, selectedDuration),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: data => {
        setStocks(data);
      },
      enabled: !!selectedFilter && !!selectedGroup && !!selectedDuration
    }
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (resultFetchedStockData?.isSuccess) {
      setStocks(resultFetchedStockData?.data?.data);
    }
  }, []);

  const getStockData = async (
    type = 'top_gainers',
    filterKey = 'index',
    filterValue = '129',
    duration = '1D'
  ) => {
    setLoading(true);
    const response = await fetch(
      `/feapi/markets/stock-stats/${type}/${filterKey}/${filterValue}/${duration}`
    );
    const data = await response.json();
    setStocks(data);
    setLoading(false);
  };
  useEffect(() => {
    getStockData(selectedFilter, selectedGroup, filterKey, selectedDuration);
  }, [selectedDuration, selectedFilter]);

  useEffect(() => {
    if (selectedGroup === 'index') {
      setFilterKeys([...indexFilterKeys]);
    } else if (selectedGroup === 'market-cap-class') {
      setFilterKeys([...marketCapFilterKeys]);
    } else if (selectedGroup === 'industry-code') {
      setFilterKeys([...industryFilterKeys]);
    } else {
      setFilterKeys([]);
    }
  }, [selectedGroup]);

  useEffect(() => {
    getStockData(selectedFilter, selectedGroup, filterKeys[0]?.value, selectedDuration);
    setFilterKey(filterKeys[0]?.value);
    setFilterKeyName(filterKeys[0]?.label);
  }, [filterKeys]);

  const setDurationFilter = duration => {
    const tempDuration = { ...durations };
    Object.keys(tempDuration)?.map(dur => {
      duration === dur ? (tempDuration[dur] = true) : (tempDuration[dur] = false);
    });
    setDurations(tempDuration);
  };

  const setMainFilters = filter => {
    setSelectedFilter(filter);
    const tempMainFilters = { ...activeFilter };
    Object.keys(tempMainFilters)?.map(fil => {
      filter === fil ? (tempMainFilters[fil] = true) : (tempMainFilters[fil] = false);
    });
    setActiveFilter(tempMainFilters);
  };

  const handleSelectedGroup = value => {
    setSelectedGroup(value?.value);
    setSelectedGroupName(value?.label);
  };

  const handleSelectedFilterKey = value => {
    setFilterKey(value?.value);
    getStockData(selectedFilter, selectedGroup, value?.value, selectedDuration);
    setFilterKeyName(value?.label);
  };

  const handleMainFilter = value => {
    setSelectedFilter(value?.value);
    setMainFilterName(value?.label);
  };

  const customStyles = {
    option: (base, state) => {
      const newStyles = Object.assign({}, base);
      if (state.isFocused) {
        newStyles.backgroundColor = 'rgb(42, 42, 42, 0.03)';
        newStyles.borderLeft = '4px solid red';
        newStyles.cursor = 'pointer';
      }
      newStyles.color = '#2a2a2a';
      return newStyles;
    },
    control: provided => {
      const border = '1.5px solid light-gray';
      const boxShadow = 'none';
      return { ...provided, border, boxShadow };
    },
    indicatorSeparator: provided => {
      const display = 'none';
      return { ...provided, display };
    },
    placeholder: provided => {
      const color = 'black';
      const width = '100%';
      return { ...provided, color, width };
    }
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="main-stats-container">
      <div styleName="stock-stats_container">
        <div styleName="stock-stats_sidebar">
          <div>FILTERS</div>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Top Gainers');
            }}
            id="top_gainers"
            styleName={`${activeFilter?.['top_gainers'] ? 'activeFilter' : ' '} `}
          >
            Top Gainers <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Top Losers');
            }}
            id="top_losers"
            styleName={`${activeFilter?.['top_losers'] ? 'activeFilter' : ' '} `}
          >
            Top Losers <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Most Active By Value');
            }}
            id="most_active_by_value"
            styleName={`${activeFilter?.['most_active_by_value'] ? 'activeFilter' : ' '} `}
          >
            Most Active <ChevronRightIcon />
          </li>

          <div>PRICE & VOL. ACTION</div>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Price Inc. & Vol Inc');
            }}
            id="price_inc_vol_inc"
            styleName={`${activeFilter?.['price_inc_vol_inc'] ? 'activeFilter' : ' '} `}
          >
            Price Incr. & Volume Incr <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Price Inc. & Vol Dec');
            }}
            id="price_inc_vol_dec"
            styleName={`${activeFilter?.['price_inc_vol_dec'] ? 'activeFilter' : ' '} `}
          >
            Price Incr. & Volume Decr <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Price Dec. & Vol Inc');
            }}
            id="price_dec_vol_inc"
            styleName={`${activeFilter?.['price_dec_vol_inc'] ? 'activeFilter' : ' '} `}
          >
            Price Decr. & Volume Incr <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Price Dec. & Vol Dec');
            }}
            id="price_dec_vol_dec"
            styleName={`${activeFilter?.['price_dec_vol_dec'] ? 'activeFilter' : ' '} `}
          >
            Price Decr. & Volume Decr <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Price Flat. & Vol Inc');
            }}
            id="price_flat_vol_inc"
            styleName={`${activeFilter?.['price_flat_vol_inc'] ? 'activeFilter' : ' '} `}
          >
            Price Flat & Volume Incr <ChevronRightIcon />
          </li>

          <div>HIGH / LOW</div>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('52 Week High');
            }}
            id="52_week_high"
            styleName={`${activeFilter['52_week_high'] ? 'activeFilter' : ' '} `}
          >
            52-week High <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('52 Week Low');
            }}
            id="52_week_low"
            styleName={`${activeFilter['52_week_low'] ? 'activeFilter' : ' '} `}
          >
            52-week Low <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Close To 52 Week High');
            }}
            id="close_to_52_week_high"
            styleName={`${activeFilter.close_to_52_week_high ? 'activeFilter' : ' '} `}
          >
            Close to 52-week High <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Close To 52 Week Low');
            }}
            id="close_to_52_week_low"
            styleName={`${activeFilter.close_to_52_week_low ? 'activeFilter' : ' '} `}
          >
            Close to 52-week Low <ChevronRightIcon />
          </li>

          <div>VOLATILE STOCKS</div>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Volatility');
            }}
            id="volatility"
            styleName={`${activeFilter?.volatility ? 'activeFilter' : ' '} `}
          >
            Volatality <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Fall From High');
            }}
            id="fall_from_high"
            styleName={`${activeFilter?.['fall_from_high'] ? 'activeFilter' : ' '} `}
          >
            Fall from high <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Rise From Low');
            }}
            id="recovery_from_low"
            styleName={`${activeFilter?.['recovery_from_low'] ? 'activeFilter' : ' '} `}
          >
            Recovery from low <ChevronRightIcon />
          </li>
          <div>BIG TRADES</div>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Bulk Deals');
            }}
            id="bulk_deal"
            styleName={`${activeFilter?.['bulk_deal'] ? 'activeFilter' : ' '} `}
          >
            Bulk Deals <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Block Deals');
            }}
            id="block_deal"
            styleName={`${activeFilter?.['block_deal'] ? 'activeFilter' : ' '} `}
          >
            Block Deals <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Insider Trading');
            }}
            id="insider"
            styleName={`${activeFilter?.['insider'] ? 'activeFilter' : ' '} `}
          >
            Insider Trading <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Only Buyers');
            }}
            id="only_buyers"
            styleName={`${activeFilter?.['only_buyers'] ? 'activeFilter' : ' '} `}
          >
            Only Buyers <ChevronRightIcon />
          </li>
          <li
            onClick={e => {
              setMainFilters(e.target.id);
              setMainFilterName('Only Sellers');
            }}
            id="only_sellers"
            styleName={`${activeFilter?.['only_sellers'] ? 'activeFilter' : ' '} `}
          >
            Only Sellers <ChevronRightIcon />
          </li>
        </div>
        <div styleName="stock-stats_right">
          <div styleName="filters">
            <div>FILTER BY</div>
            <div styleName="stock-stats_filter">
              {mainFilters?.length > 0 && (
                <div styleName="external-btn">
                  <Select
                    options={mainFilters}
                    onChange={handleMainFilter}
                    placeholder={MainFilterName}
                    value={selectedFilter}
                    styles={customStyles}
                  />
                </div>
              )}
              {groupFilters?.length > 0 && (
                <div styleName="external-btn">
                  <Select
                    options={groupFilters}
                    onChange={handleSelectedGroup}
                    placeholder={selectedGroupName}
                    value={selectedGroup}
                    styles={customStyles}
                  />
                </div>
              )}
              {filterKeys?.length > 0 && (
                <div styleName="external-btn">
                  <Select
                    options={filterKeys}
                    onChange={handleSelectedFilterKey}
                    placeholder={FilterkeyName}
                    value={selectedFilter}
                    styles={customStyles}
                  />
                </div>
              )}
            </div>
            {selectedFilter?.startsWith('top') && (
              <div styleName="btn-container">
                <button
                  id="oneD"
                  styleName={`filter-btn ${durations.oneD ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('1D');
                  }}
                >
                  1D
                </button>
                <button
                  id="oneW"
                  styleName={`filter-btn ${durations.oneW ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('1W');
                  }}
                >
                  1W
                </button>
                <button
                  id="oneM"
                  styleName={`filter-btn ${durations.oneM ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('1M');
                  }}
                >
                  1M
                </button>
                <button
                  id="oneYTD"
                  styleName={`filter-btn ${durations.oneYTD ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('YTD');
                  }}
                >
                  YTD
                </button>
                <button
                  id="oneY"
                  styleName={`filter-btn ${durations.oneY ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('1Y');
                  }}
                >
                  1Y
                </button>
                <button
                  id="threeY"
                  styleName={`filter-btn ${durations.threeY ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('3Y');
                  }}
                >
                  3Y
                </button>
                <button
                  id="fiveY"
                  styleName={`filter-btn ${durations.fiveY ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('5Y');
                  }}
                >
                  5Y
                </button>
                <button
                  id="tenY"
                  styleName={`filter-btn ${durations.tenY ? 'selected' : ' '} `}
                  onClick={e => {
                    setDurationFilter(e.target.id);
                    setSelectedDuration('10Y');
                  }}
                >
                  10Y
                </button>
              </div>
            )}
            <div styleName="currentFilters">
              <h5>{`You are currently viewing ${MainFilterName}`}</h5>
              <h6>{`In ${selectedGroupName} > ${FilterkeyName} > ${selectedDuration}`}</h6>
            </div>
          </div>
          <div styleName="stock-stats_table">
            <table>
              <tr>
                <th styleName="table-overall-style table-header">COMPANY</th>
                {selectedFilter === '52_week_high' && (
                  <th styleName="table-overall-style table-header">52 WEEK HIGH</th>
                )}
                {selectedFilter === '52_week_low' && (
                  <th styleName="table-overall-style table-header">52 WEEK LOW</th>
                )}
                {selectedFilter === 'close_to_52_week_high' && (
                  <th styleName="table-overall-style table-header">CLOSE TO 52-WEEK HIGH</th>
                )}
                {selectedFilter === 'close_to_52_week_low' && (
                  <th styleName="table-overall-style table-header">CLOSE TO 52-WEEK LOW</th>
                )}
                {selectedFilter === 'most_active_by_value' && (
                  <th styleName="table-overall-style table-header">VOLUME</th>
                )}
                {selectedFilter === 'bulk_deal' && (
                  <th styleName="table-overall-style table-header">VOLUME</th>
                )}
                {selectedFilter === 'block_deal' && (
                  <th styleName="table-overall-style table-header">VOLUME</th>
                )}
                {selectedFilter === 'insider' && (
                  <th styleName="table-overall-style table-header">VOLUME</th>
                )}
                {selectedFilter === 'only_buyers' && (
                  <th styleName="table-overall-style table-header">VOLUME</th>
                )}
                {selectedFilter === 'only_sellers' && (
                  <th styleName="table-overall-style table-header">VOLUME</th>
                )}
                {selectedFilter === 'volatility' && (
                  <th styleName="table-overall-style table-header">HIGH/LOW</th>
                )}
                {selectedFilter === 'recovery_from_low' && (
                  <th styleName="table-overall-style table-header">HIGH/LOW</th>
                )}
                {selectedFilter === 'fall_from_high' && (
                  <th styleName="table-overall-style table-header">HIGH/LOW</th>
                )}
                {selectedFilter.startsWith('price') && (
                  <th styleName="table-overall-style table-header">VOLUME</th>
                )}
                {selectedFilter.startsWith('top') && (
                  <th styleName="table-overall-style table-header">HIGH/LOW</th>
                )}
                {selectedFilter === 'bulk_deal' && (
                  <th styleName="table-overall-style table-header">PRICE</th>
                )}
                {selectedFilter === 'block_deal' && (
                  <th styleName="table-overall-style table-header">PRICE</th>
                )}
                {selectedFilter === 'insider' && (
                  <th styleName="table-overall-style table-header">PRICE</th>
                )}
                {selectedFilter === 'only_buyers' && (
                  <th styleName="table-overall-style table-header">PRICE</th>
                )}
                {selectedFilter === 'only_sellers' && (
                  <th styleName="table-overall-style table-header">PRICE</th>
                )}
                {!(
                  selectedFilter === 'bulk_deal' ||
                  selectedFilter === 'block_deal' ||
                  selectedFilter === 'insider' ||
                  selectedFilter === 'only_buyers' ||
                  selectedFilter === 'only_sellers'
                ) && <th styleName="table-overall-style table-header">CHANGE</th>}
              </tr>
              {Loading ? (
                <div styleName="loader">
                  <Loader color={'#dadde1'} />
                </div>
              ) : stocks?.data?.length > 0 ? (
                stocks?.data?.map(stock => (
                  <tr key={stock?.id}>
                    <td styleName="table-overall-style">
                      <BQLink
                        href={`/stock/${stock.id}/${stock?.name
                          ?.toLowerCase()
                          .trim()
                          .replaceAll(' ', '-')
                          .split('-')
                          .filter(val => val !== '')
                          .map(val => val.replaceAll('.', ''))
                          .join('-')}`}
                        target="_blank"
                      >
                        <span styleName="stock-name">{stock.name}</span>
                      </BQLink>

                      <br />
                      <span styleName="stock-last-price">{stock['last-price']}</span>
                    </td>
                    <td styleName="table-overall-style">
                      {stock.high ? (
                        <>
                          <span styleName="stock-high-val">{stock.high}</span>/
                          <span>{stock.low}</span>
                        </>
                      ) : (
                        stock.volume ??
                        stock.vol ??
                        stock['latest-volume'] ??
                        stock['52wk-high'] ??
                        stock['52wk-low'] ??
                        '-'
                      )}
                    </td>
                    {selectedFilter === 'bulk_deal' ||
                    selectedFilter === 'block_deal' ||
                    selectedFilter === 'insider' ||
                    selectedFilter === 'only_buyers' ||
                    selectedFilter === 'only_sellers' ? (
                      <td styleName="table-overall-style">{stock.price ? stock.price : '-'}</td>
                    ) : (
                      <td styleName="table-overall-style">
                        {String(stock.chgp).includes('-') ? (
                          <span styleName="negative-value">&#9660;{stock.chgp}%</span>
                        ) : (
                          <span styleName="positive-value">&#9650;+{stock.chgp}%</span>
                        )}
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr styleName="empty-row">
                  <td colSpan="3" styleName="no-data">
                    <div styleName="no-data-container-ext">
                      <div styleName="no-data-container-int">
                        <EmptyState />
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockStats;
